// @ts-nocheck
import React, { useEffect, useState } from "react";
import { delete_icon, edit_icon } from "../../../../assets/img";
import Select from "react-select";
import moment from "moment";

const DatePrice = ({
  date,
  customStyles,
  viewOnly,
  formData,
  setFormData,
  handleSubmit,
  specialpriceData,
  handleDateChangeInForm,
  handleDelete,
}) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [deletePopup, setDeletePopup] = useState(false);
  const [editable, setEditable] = useState(!Boolean(formData?.id));
  const [slot_timing, setSlot_timing] = useState([]);
  useEffect(() => {
    setEditable(!Boolean(formData?.id));
  }, [formData?.id]);

  const [slot_durations, setSlot_durations] = useState([]);

  useEffect(() => {
    if (specialpriceData?.availableSlots?.length === 0) return;
    let filtered = [];
    specialpriceData?.availableSlots?.forEach((item) => {
      let exist = filtered.findIndex((s) => item?.label === s?.label);
      if (exist < 0) {
        filtered.push(item);
      }
    });
    setSlot_durations(filtered);
  }, [specialpriceData?.availableSlots]);

  const handleSlotTiming = (selected) => {
    let filtered = [];
    specialpriceData?.availableSlots?.forEach((item) => {
      if (item?.label === selected?.label) {
        filtered.push({ value: item?.id, label: item?.timeslot_type });
      }
    });
    setSlot_timing(filtered);
  };

  const handleChangePrices = (e) => {
    const find_slot = specialpriceData?.slotsList?.find(
      (s) => s.time_slot === e?.value,
    );
    const {
      id,
      property_price,
      vow_commision,
      extra_person_price,
      extra_person_commision,
    } = find_slot;

    setFormData((prev) => ({
      ...prev,
      propPrice: Number(property_price).toFixed(0),
      vowCommission: Number(vow_commision).toFixed(0),
      extraPrice: Number(extra_person_price).toFixed(0),
      extraCommission: Number(extra_person_commision).toFixed(0),
      Slot_id: id,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let gst = Number(specialpriceData?.gst);
    let commission = Math.round((value / 100) * gst).toFixed(0);
    let commisionType =
      name === "specialPrice" ? "specialCommission" : "specialExtraCommission";
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      [commisionType]: commission,
    }));
  };

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="">
      <div
        className="slot-box rounded-4"
        style={{ border: "1px solid #454545" }}
      >
        <div className="d-flex flex-wrap gap-5 mt-4 col-md-12">
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Date
            </p>
            <div className="col-md-12 d-flex ac-jb">
              <div className="col-md-5">
                <input
                  name="date"
                  type="date"
                  className="input-box"
                  value={selectedDate}
                  disabled={!editable}
                  onChange={(e) => {
                    setSelectedDate(e.target.value);
                    handleDateChangeInForm(
                      moment(e.target.value, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    );
                  }}
                />
              </div>
              <div className="col-md-5">
                <input
                  type="text"
                  className="input-box"
                  value={moment(selectedDate, "YYYY-MM-DD").format("dddd")}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Slot Type
            </p>
            <div className="col-md-12 d-flex ac-jb">
              <div className="col-md-5">
                <Select
                  isDisabled={!editable || formData?.id}
                  options={slot_durations}
                  value={formData?.slotType}
                  onChange={(e) => {
                    handleDropdownChange("slotType", e);
                    handleSlotTiming(e);
                  }}
                  placeholder="Select "
                  styles={customStyles}
                />
              </div>
              <div className="col-md-5">
                <Select
                  isDisabled={!editable || formData?.id}
                  options={slot_timing}
                  onChange={(e) => {
                    handleDropdownChange("slotTime", e);
                    handleChangePrices(e);
                  }}
                  value={formData?.slotTime}
                  placeholder="Select "
                  styles={customStyles}
                />
              </div>
            </div>
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Properties Price
            </p>
            <input
              className="input-box"
              name="propPrice"
              value={formData?.propPrice}
              disabled
              type="number"
              placeholder="Properties Price"
            />
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Vow Commission
            </p>
            <input
              className="input-box"
              name="vowCommission"
              value={formData?.vowCommission}
              disabled
              type="number"
              placeholder="Vow Commission"
            />
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Property Extra Person Price
            </p>
            <input
              className="input-box"
              name="extraPrice"
              value={formData?.extraPrice}
              disabled
              type="number"
              placeholder="Property Extra Person Price"
            />
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Vow Extra Commission
            </p>
            <input
              className="input-box"
              name="extraCommission"
              value={formData?.extraCommission}
              disabled
              type="number"
              placeholder="Vow Extra Commission"
            />
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Special Date Property Price
            </p>
            <input
              className="input-box"
              name="specialPrice"
              value={formData?.specialPrice}
              // value={
              //   formData?.specialPrice &&
              //   Number(formData?.specialPrice).toFixed(0)
              // }
              disabled={!editable}
              onChange={handleChange}
              type="number"
              placeholder="Property Extra Person Price"
            />
            <p className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mb-1 red">
              * {specialpriceData?.gst}% will be add as VOW commission
            </p>
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Special Date Vow Commission
            </p>
            <input
              className="input-box"
              name="specialCommission"
              value={formData?.specialCommission}
              disabled
              type="number"
              placeholder="Vow Extra Commission"
            />
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Special Property Extra Person Price
            </p>
            <input
              className="input-box"
              name="specialExtraPrice"
              value={formData?.specialExtraPrice}
              // value={
              //   formData?.specialExtraPrice &&
              //   Number(formData?.specialExtraPrice).toFixed(0)
              // }
              disabled={!editable}
              onChange={handleChange}
              type="number"
              placeholder="Property Extra Person Price"
            />
            <p className="f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mb-1 red">
              * {specialpriceData?.gst}% will be add as VOW commission
            </p>
          </div>
          <div className={`col-md-5 ${!editable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Special Vow Extra Commission
            </p>
            <input
              className="input-box"
              name="specialExtraCommission"
              value={formData?.specialExtraCommission}
              disabled
              type="number"
              placeholder="Vow Extra Commission"
            />
          </div>
        </div>
        <div className="d-flex ac-jb my-4">
          {!viewOnly && editable ? (
            <button
              onClick={handleSubmit}
              className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
            >
              Submit
            </button>
          ) : (
            <div />
          )}
          {!viewOnly && formData?.id && (
            <div className="d-flex gap-3">
              <div className="d-flex gap-2 align-items-start">
                <div className="text-center">
                  <button
                    onClick={() => setEditable(!editable)}
                    className="cust-btn"
                  >
                    <img src={edit_icon} className="edit-btn" alt="edit" />
                  </button>
                  <p className="f3 fs-sm-12 fs-md-14 my-1">
                    {!editable ? "Edit" : "Cancel"}
                  </p>
                </div>
                <div className="text-center">
                  <button
                    onClick={() => setDeletePopup(true)}
                    className="cust-btn"
                  >
                    <img src={delete_icon} className="edit-btn" alt="delete" />
                  </button>
                  <p className="f3 fs-sm-12 fs-md-14 my-1 invisible">label</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  setDeletePopup(false);
                  handleDelete?.(formData?.id);
                }}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDeletePopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePrice;
